// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* =====================================
   PAGE
===================================== */

.admin-users-page {
    width: 100%;
    min-width: 0;
  }
  
  
  /* =====================================
     HEADER
  ===================================== */
  
  .admin-users-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 20px;
  
    margin-bottom: 28px;
  }
  
  
  .admin-users-header h1 {
    margin: 0;
  
    font-size: clamp(
      22px,
      3vw,
      28px
    );
  
    font-weight: 700;
  
    color: #111827;
  }
  
  
  .admin-users-header p {
    margin: 8px 0 0;
  
    font-size: 14px;
    line-height: 1.6;
  
    color: #667085;
  }
  
  
  /* =====================================
     TABLE WRAPPER
  ===================================== */
  
  .admin-users-table-wrapper {
    width: 100%;
    min-width: 0;
  
    background: #ffffff;
  
    border:
      1px solid #e8eaf0;
  
    border-radius: 14px;
  
    overflow-x: auto;
  
    -webkit-overflow-scrolling: touch;
  }
  
  
  /* =====================================
     TABLE
  ===================================== */
  
  .admin-users-table {
    width: 100%;
  
    border-collapse: collapse;
  }
  
  
  .admin-users-table th {
    padding: 15px 20px;
  
    background: #f8fafc;
  
    border-bottom:
      1px solid #e8eaf0;
  
    text-align: left;
  
    font-size: 12px;
    font-weight: 600;
  
    color: #667085;
  
    text-transform: uppercase;
    letter-spacing: 0.04em;
  
    white-space: nowrap;
  }
  
  
  .admin-users-table td {
    padding: 17px 20px;
  
    border-bottom:
      1px solid #eef0f4;
  
    font-size: 14px;
  
    color: #344054;
  }
  
  
  .admin-users-table
  tbody
  tr:last-child
  td {
    border-bottom: none;
  }
  
  
  /* =====================================
     ROW
  ===================================== */
  
  .admin-users-row {
    cursor: pointer;
  
    transition:
      background 0.2s ease;
  }
  
  
  .admin-users-row:hover {
    background: #f9fafb;
  }
  
  
  /* =====================================
     NAME
  ===================================== */
  
  .admin-user-name {
    font-weight: 600;
  
    color: #101828;
  }
  
  
  /* =====================================
     STATUS
  ===================================== */
  
  .admin-status-badge {
    display: inline-flex;
    align-items: center;
  
    padding: 5px 10px;
  
    border-radius: 999px;
  
    font-size: 12px;
    font-weight: 600;
  
    white-space: nowrap;
  }
  
  
  .admin-status-badge.pending {
    background: #fff7e6;
    color: #b54708;
  }
  
  
  .admin-status-badge.verified {
    background: #ecfdf3;
    color: #027a48;
  }
  
  
  .admin-status-badge.rejected {
    background: #fef3f2;
    color: #b42318;
  }
  
  
  /* =====================================
     STATES
  ===================================== */
  
  .admin-users-loading,
  .admin-users-empty {
    padding: 40px 20px;
  
    background: #ffffff;
  
    border:
      1px solid #e8eaf0;
  
    border-radius: 14px;
  
    text-align: center;
  
    color: #667085;
  }
  
  
  .admin-users-error {
    padding: 16px 18px;
  
    background: #fef3f2;
  
    border:
      1px solid #fecdca;
  
    border-radius: 10px;
  
    color: #b42318;
  }
  
  
  /* =====================================
     TABLET
  ===================================== */
  
  @media (max-width: 800px) {
  
    .admin-users-header {
      align-items: flex-start;
      flex-direction: column;
  
      margin-bottom: 20px;
    }
  
  
    .admin-users-table th,
    .admin-users-table td {
      padding:
        14px 16px;
    }
  
  }
  
  
  /* =====================================
     MOBILE CARD TABLE
  ===================================== */
  
  @media (max-width: 600px) {
  
    .admin-users-header {
      margin-bottom: 18px;
    }
  
  
    .admin-users-header p {
      font-size: 13px;
    }
  
  
    .admin-users-table-wrapper {
      overflow: visible;
  
      background: transparent;
  
      border: none;
      border-radius: 0;
    }
  
  
    .admin-users-table,
    .admin-users-table tbody,
    .admin-users-table tr,
    .admin-users-table td {
      display: block;
  
      width: 100%;
    }
  
  
    .admin-users-table thead {
      display: none;
    }
  
  
    .admin-users-table tbody {
      display: flex;
      flex-direction: column;
      gap: 12px;
    }
  
  
    .admin-users-table tr {
      padding: 16px;
  
      background: #ffffff;
  
      border:
        1px solid #e8eaf0;
  
      border-radius: 14px;
  
      box-sizing: border-box;
    }
  
  
    .admin-users-table td {
      padding: 0;
  
      border: none;
    }
  
  
    .admin-users-table td + td {
      margin-top: 12px;
    }
  
  
    .admin-users-table td:nth-child(2) {
      font-size: 13px;
  
      color: #667085;
    }
  
  
    .admin-user-name {
      display: block;
  
      font-size: 15px;
    }
  
  
    .admin-status-badge {
      margin-top: 2px;
    }
  
  
    .admin-users-row:hover {
      background: #ffffff;
    }
  
  
    .admin-users-row:active {
      transform:
        scale(0.99);
  
      background: #f9fafb;
    }
  
  }`, "",{"version":3,"sources":["webpack://./src/admin/styles/AdminUsers.css"],"names":[],"mappings":"AAAA;;uCAEuC;;AAEvC;IACI,WAAW;IACX,YAAY;EACd;;;EAGA;;yCAEuC;;EAEvC;IACE,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,SAAS;;IAET,mBAAmB;EACrB;;;EAGA;IACE,SAAS;;IAET;;;;KAIC;;IAED,gBAAgB;;IAEhB,cAAc;EAChB;;;EAGA;IACE,eAAe;;IAEf,eAAe;IACf,gBAAgB;;IAEhB,cAAc;EAChB;;;EAGA;;yCAEuC;;EAEvC;IACE,WAAW;IACX,YAAY;;IAEZ,mBAAmB;;IAEnB;uBACmB;;IAEnB,mBAAmB;;IAEnB,gBAAgB;;IAEhB,iCAAiC;EACnC;;;EAGA;;yCAEuC;;EAEvC;IACE,WAAW;;IAEX,yBAAyB;EAC3B;;;EAGA;IACE,kBAAkB;;IAElB,mBAAmB;;IAEnB;uBACmB;;IAEnB,gBAAgB;;IAEhB,eAAe;IACf,gBAAgB;;IAEhB,cAAc;;IAEd,yBAAyB;IACzB,sBAAsB;;IAEtB,mBAAmB;EACrB;;;EAGA;IACE,kBAAkB;;IAElB;uBACmB;;IAEnB,eAAe;;IAEf,cAAc;EAChB;;;EAGA;;;;IAIE,mBAAmB;EACrB;;;EAGA;;yCAEuC;;EAEvC;IACE,eAAe;;IAEf;0BACsB;EACxB;;;EAGA;IACE,mBAAmB;EACrB;;;EAGA;;yCAEuC;;EAEvC;IACE,gBAAgB;;IAEhB,cAAc;EAChB;;;EAGA;;yCAEuC;;EAEvC;IACE,oBAAoB;IACpB,mBAAmB;;IAEnB,iBAAiB;;IAEjB,oBAAoB;;IAEpB,eAAe;IACf,gBAAgB;;IAEhB,mBAAmB;EACrB;;;EAGA;IACE,mBAAmB;IACnB,cAAc;EAChB;;;EAGA;IACE,mBAAmB;IACnB,cAAc;EAChB;;;EAGA;IACE,mBAAmB;IACnB,cAAc;EAChB;;;EAGA;;yCAEuC;;EAEvC;;IAEE,kBAAkB;;IAElB,mBAAmB;;IAEnB;uBACmB;;IAEnB,mBAAmB;;IAEnB,kBAAkB;;IAElB,cAAc;EAChB;;;EAGA;IACE,kBAAkB;;IAElB,mBAAmB;;IAEnB;uBACmB;;IAEnB,mBAAmB;;IAEnB,cAAc;EAChB;;;EAGA;;yCAEuC;;EAEvC;;IAEE;MACE,uBAAuB;MACvB,sBAAsB;;MAEtB,mBAAmB;IACrB;;;IAGA;;MAEE;iBACW;IACb;;EAEF;;;EAGA;;yCAEuC;;EAEvC;;IAEE;MACE,mBAAmB;IACrB;;;IAGA;MACE,eAAe;IACjB;;;IAGA;MACE,iBAAiB;;MAEjB,uBAAuB;;MAEvB,YAAY;MACZ,gBAAgB;IAClB;;;IAGA;;;;MAIE,cAAc;;MAEd,WAAW;IACb;;;IAGA;MACE,aAAa;IACf;;;IAGA;MACE,aAAa;MACb,sBAAsB;MACtB,SAAS;IACX;;;IAGA;MACE,aAAa;;MAEb,mBAAmB;;MAEnB;yBACmB;;MAEnB,mBAAmB;;MAEnB,sBAAsB;IACxB;;;IAGA;MACE,UAAU;;MAEV,YAAY;IACd;;;IAGA;MACE,gBAAgB;IAClB;;;IAGA;MACE,eAAe;;MAEf,cAAc;IAChB;;;IAGA;MACE,cAAc;;MAEd,eAAe;IACjB;;;IAGA;MACE,eAAe;IACjB;;;IAGA;MACE,mBAAmB;IACrB;;;IAGA;MACE;mBACa;;MAEb,mBAAmB;IACrB;;EAEF","sourcesContent":["/* =====================================\n   PAGE\n===================================== */\n\n.admin-users-page {\n    width: 100%;\n    min-width: 0;\n  }\n  \n  \n  /* =====================================\n     HEADER\n  ===================================== */\n  \n  .admin-users-header {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 20px;\n  \n    margin-bottom: 28px;\n  }\n  \n  \n  .admin-users-header h1 {\n    margin: 0;\n  \n    font-size: clamp(\n      22px,\n      3vw,\n      28px\n    );\n  \n    font-weight: 700;\n  \n    color: #111827;\n  }\n  \n  \n  .admin-users-header p {\n    margin: 8px 0 0;\n  \n    font-size: 14px;\n    line-height: 1.6;\n  \n    color: #667085;\n  }\n  \n  \n  /* =====================================\n     TABLE WRAPPER\n  ===================================== */\n  \n  .admin-users-table-wrapper {\n    width: 100%;\n    min-width: 0;\n  \n    background: #ffffff;\n  \n    border:\n      1px solid #e8eaf0;\n  \n    border-radius: 14px;\n  \n    overflow-x: auto;\n  \n    -webkit-overflow-scrolling: touch;\n  }\n  \n  \n  /* =====================================\n     TABLE\n  ===================================== */\n  \n  .admin-users-table {\n    width: 100%;\n  \n    border-collapse: collapse;\n  }\n  \n  \n  .admin-users-table th {\n    padding: 15px 20px;\n  \n    background: #f8fafc;\n  \n    border-bottom:\n      1px solid #e8eaf0;\n  \n    text-align: left;\n  \n    font-size: 12px;\n    font-weight: 600;\n  \n    color: #667085;\n  \n    text-transform: uppercase;\n    letter-spacing: 0.04em;\n  \n    white-space: nowrap;\n  }\n  \n  \n  .admin-users-table td {\n    padding: 17px 20px;\n  \n    border-bottom:\n      1px solid #eef0f4;\n  \n    font-size: 14px;\n  \n    color: #344054;\n  }\n  \n  \n  .admin-users-table\n  tbody\n  tr:last-child\n  td {\n    border-bottom: none;\n  }\n  \n  \n  /* =====================================\n     ROW\n  ===================================== */\n  \n  .admin-users-row {\n    cursor: pointer;\n  \n    transition:\n      background 0.2s ease;\n  }\n  \n  \n  .admin-users-row:hover {\n    background: #f9fafb;\n  }\n  \n  \n  /* =====================================\n     NAME\n  ===================================== */\n  \n  .admin-user-name {\n    font-weight: 600;\n  \n    color: #101828;\n  }\n  \n  \n  /* =====================================\n     STATUS\n  ===================================== */\n  \n  .admin-status-badge {\n    display: inline-flex;\n    align-items: center;\n  \n    padding: 5px 10px;\n  \n    border-radius: 999px;\n  \n    font-size: 12px;\n    font-weight: 600;\n  \n    white-space: nowrap;\n  }\n  \n  \n  .admin-status-badge.pending {\n    background: #fff7e6;\n    color: #b54708;\n  }\n  \n  \n  .admin-status-badge.verified {\n    background: #ecfdf3;\n    color: #027a48;\n  }\n  \n  \n  .admin-status-badge.rejected {\n    background: #fef3f2;\n    color: #b42318;\n  }\n  \n  \n  /* =====================================\n     STATES\n  ===================================== */\n  \n  .admin-users-loading,\n  .admin-users-empty {\n    padding: 40px 20px;\n  \n    background: #ffffff;\n  \n    border:\n      1px solid #e8eaf0;\n  \n    border-radius: 14px;\n  \n    text-align: center;\n  \n    color: #667085;\n  }\n  \n  \n  .admin-users-error {\n    padding: 16px 18px;\n  \n    background: #fef3f2;\n  \n    border:\n      1px solid #fecdca;\n  \n    border-radius: 10px;\n  \n    color: #b42318;\n  }\n  \n  \n  /* =====================================\n     TABLET\n  ===================================== */\n  \n  @media (max-width: 800px) {\n  \n    .admin-users-header {\n      align-items: flex-start;\n      flex-direction: column;\n  \n      margin-bottom: 20px;\n    }\n  \n  \n    .admin-users-table th,\n    .admin-users-table td {\n      padding:\n        14px 16px;\n    }\n  \n  }\n  \n  \n  /* =====================================\n     MOBILE CARD TABLE\n  ===================================== */\n  \n  @media (max-width: 600px) {\n  \n    .admin-users-header {\n      margin-bottom: 18px;\n    }\n  \n  \n    .admin-users-header p {\n      font-size: 13px;\n    }\n  \n  \n    .admin-users-table-wrapper {\n      overflow: visible;\n  \n      background: transparent;\n  \n      border: none;\n      border-radius: 0;\n    }\n  \n  \n    .admin-users-table,\n    .admin-users-table tbody,\n    .admin-users-table tr,\n    .admin-users-table td {\n      display: block;\n  \n      width: 100%;\n    }\n  \n  \n    .admin-users-table thead {\n      display: none;\n    }\n  \n  \n    .admin-users-table tbody {\n      display: flex;\n      flex-direction: column;\n      gap: 12px;\n    }\n  \n  \n    .admin-users-table tr {\n      padding: 16px;\n  \n      background: #ffffff;\n  \n      border:\n        1px solid #e8eaf0;\n  \n      border-radius: 14px;\n  \n      box-sizing: border-box;\n    }\n  \n  \n    .admin-users-table td {\n      padding: 0;\n  \n      border: none;\n    }\n  \n  \n    .admin-users-table td + td {\n      margin-top: 12px;\n    }\n  \n  \n    .admin-users-table td:nth-child(2) {\n      font-size: 13px;\n  \n      color: #667085;\n    }\n  \n  \n    .admin-user-name {\n      display: block;\n  \n      font-size: 15px;\n    }\n  \n  \n    .admin-status-badge {\n      margin-top: 2px;\n    }\n  \n  \n    .admin-users-row:hover {\n      background: #ffffff;\n    }\n  \n  \n    .admin-users-row:active {\n      transform:\n        scale(0.99);\n  \n      background: #f9fafb;\n    }\n  \n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
